"use client";

import { Button } from "@/components/cognito-ui/primitives/Button";

export default function ErrorPage({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  return (
    <main className="cui-route-state" role="alert">
      <div className="cui-route-state-icon">!</div>
      <h1>This page could not be displayed</h1>
      <p>Cognito encountered an unexpected application error. Try the page again; your saved data has not been changed.</p>
      <Button onClick={reset} variant="primary">Try again</Button>
      {error.digest ? <small>Reference: {error.digest}</small> : null}
    </main>
  );
}
